export default __webpack_public_path__ + "static/media/class_xi_xii_medical.08d79a0d.png";